<template>
  <UninstallLayout 
    :title="$t('uninstall.cautions.title')"
  >
    <template #description>
      <p class="uninstall-cautions-description">{{ $t('uninstall.cautions.desc') }}</p>
    </template>
    <template #leftContent>
      <div class="uninstall-cautions-list">
        <div class="uninstall-cautions-list-item" v-for="(item, index) in cautionsList" :key="index">
          <p class="uninstall-cautions-list-item__label">{{ item.label }}</p>
          <p class="uninstall-cautions-list-item__desc" v-html="item.description"></p>
        </div>
        <div class="uninstall-cautions__confirm">
          <p class="uninstall-cautions-list-item__label">{{ $t('uninstall.cautions.confirm.label') }}</p>
          <div class="uninstall-cautions__confirm-card-wrapper">
            <GpCheckbox v-for="(item, index) in confirmItems" :key="index" class="uninstall-cautions__confirm-card" align="start" size="medium" :value="item" :label="item" v-model="checkedConfirmItems"/>
          </div>
        </div>
      </div>
      <div class="d-flex">
        <button class="btn btn-secondary2 px-2 mr-2" :disabled="disabledContinue" @click="handleContinueUninstall">{{ $t('uninstall.continue') }}</button>
        <button class="btn btn-primary px-2" @click="goToNewSetting">{{ $t('uninstall.stayWithGemPages') }}</button>
      </div>
    </template>
  </UninstallLayout>
</template>

<script>
import UninstallLayout from "../components/UninstallLayout.vue";
import { GpCheckbox } from "@/core/shared/GpForms";
import { mapState } from "vuex";

export default {
  name: 'UninstallCautions',
  components: {
    GpCheckbox,
    UninstallLayout,
  },
  data() {
    return {
      checkedConfirmItems: [],
      confirmItems: [
        // this.$t('uninstall.cautions.dataStored.confirm'),
        this.$t('uninstall.cautions.publishedPages.confirm'),
        this.$t('uninstall.cautions.billing.confirm'),
      ],
      cautionsList: [
        // {
        //   label: this.$t('uninstall.cautions.dataStored.label'),
        //   description: this.$t('uninstall.cautions.dataStored.desc')
        // },
        {
          label: this.$t('uninstall.cautions.publishedPages.label'),
          description: this.$t('uninstall.cautions.publishedPages.desc')
        },
        {
          label: this.$t('uninstall.cautions.billing.label'),
          description: this.$t('uninstall.cautions.billing.desc')
        },
      ]
    }
  },
  computed: {
    ...mapState("account", {
      shopInfo: state => state.shopInfo
    }),
    disabledContinue() {
      return this.checkedConfirmItems.length !== this.confirmItems.length; 
    }
  },
  methods: {
    handleContinueUninstall() {
      this.$emit('continue');
    },
    goToNewSetting() {
      const domain = this.shopInfo.shopifyDomain.replace('.myshopify.com', '')
      const appId = process.env.VUE_APP_GEMPAGES_APP_ID
      window.top.location.href = `https://admin.shopify.com/store/${domain}/apps/${appId}/app/preferences`
    }
  },
}
</script>

<style scoped lang="scss">
.btn {
  height: 40px !important;

  &.btn-secondary2:disabled {
    background: $light2 !important;
    color: $textLightModeDisabled !important;
  }
}
.uninstall-cautions-description {
  margin-top: 16px;
  color: $textLightModeHigh;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
}
.uninstall-cautions-list {
  display: flex;
  flex-direction: column;
  gap: 24px;

  &-item {
    display: flex;
    flex-direction: column;
    gap: 8px;

    &__label {
      color: $textLightModeHigh;
      font-size: 16px;
      font-weight: 600;
      line-height: 24px;
      letter-spacing: -0.32px;
    }
    
    &__desc {
      color: $dark6;
      font-size: 14px;
      font-weight: 400;
      line-height: 24px;
    }

  }
}
.uninstall-cautions__confirm {
  display: flex;
  flex-direction: column;
  gap: 16px;

  &-card-wrapper {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  &-card {
    @include trans-all;
    cursor: pointer;
    border-radius: 6px;
    border: solid 1px $light3;
    padding: 12px;
    color: $textLightModeHigh;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;

    &:hover {
      border-color: $mono3;
    }
  }
}      
</style>
